import { useCurrentUserStore } from "@/stores/CurrentUserStore";
import { AccountDefaults } from "@/types/accounts/AccountDefaults";
import { CurrentUser } from "@/types/user/CurrentUser";
import { ref, onMounted } from "vue";

export function useUserHelper() {
  const currentUserStore = useCurrentUserStore();
  const currentUserDetails = ref<CurrentUser>(
    AccountDefaults.defaultCurrentUserDetails(),
  );

  const fetchUserDetails = async () => {
    currentUserDetails.value = await currentUserStore.getCurrentUserDetails();
  };

  onMounted(fetchUserDetails);

  return {
    currentUserDetails,
    fetchUserDetails,
  };
}
